import React from 'react';
import OldSearcher from './index2';
import NewSearcher from './index';
import Metadata from 'src/requests/apa/Metadata';
import DeviceStorage from 'src/components/DeviceStorage/DeviceStorage';

const newSearcherConfigDefault = {
    default: { enable: false },
};

const ChooseSearcher = (props: any) => {
    const newSearcherConfigMetadata = Metadata.get(
        'new_searcher_config',
        JSON.stringify(newSearcherConfigDefault)
    );

    const valueOfMetadata = () => {
        const region = DeviceStorage.getItem('region');
        const metadata = JSON.parse(newSearcherConfigMetadata);

        const metadataDefault = metadata.default ? metadata.default.enable : null;
        const metadataRegion = metadata[region] ? metadata[region].enable : null;

        const activateNewSearch = metadataRegion !== null ? metadataRegion : metadataDefault;

        return typeof activateNewSearch === 'boolean' ? activateNewSearch : false;
    };

    const activateNewSearch = valueOfMetadata();

    return (
        <span>{activateNewSearch ? <NewSearcher {...props} /> : <OldSearcher {...props} />}</span>
    );
};

export default ChooseSearcher;



// WEBPACK FOOTER //
// ./src/containers/Search/ChooseSearcher.tsx